import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { selectVisibleColumns } from '../selectors/selectVisibleColumns';

type SetTableRowDetail = {
  index: number | null;
  expandedColumn?: string;
};

export const setTableRowDetail: TableCommandFactory<SetTableRowDetail> =
  (cmdContext) => (command) => {
    if (command.index === null) {
      cmdContext.updateState((draft) => {
        draft.tableRowDetail = null;
      });
    } else {
      const state = cmdContext.getState();
      const columns = selectVisibleColumns(state);
      const row = state.data[command.index];
      if (!row) {
        stumble('Trying to open table row detail for not loaded row');
        return;
      }

      cmdContext.updateState((draft) => {
        draft.tableRowDetail = {
          columns,
          row,
          expandedColumns: new Set(
            command.expandedColumn ? [command.expandedColumn] : [],
          ),
        };
      });
    }
  };
